import React from 'react';
import './About.css';

import foto from '../../assets/Foto_kranhalle.jpg';


export const About = () => {

    const description = <p>

        MondWild ist Singer-Songwriterin, Produzentin und Live Electronic Act aus München. Sie verbindet deutschsprachiges Storytelling und Indie-Gesang mit Dream House. Ihr Sound ist tanzbar und atmosphärisch dicht, zwischen Clubenergie und Intimität.
   <br /><br />
Ihre Songs erzählen von inneren Umbrüchen: von Anpassung zu Freiheit, von Overthinking zu Intuition, von Selbstzweifeln zu Selbstannahme. Es geht um die Frage, wie man sich selbst in einer lauten Welt wieder näher kommt. Dabei treffen persönliche Geschichten und emotionale Tiefe auf Musik, die trägt und öffnet.
  <br /><br />
MondWild schreibt und produziert ihre Musik selbst. Auf der Bühne performt sie ihre eigenen Songs mit Stimme, MIDI-Controllern und Ableton Live. So verbindet ihre Live-Show die Nähe eines Singer-Songwriter-Konzerts mit der Energie eines House-Sets. Für sie gehören Tanzen und Fühlen zusammen: Freude muss das Schwere nicht ausblenden.
   <br /><br />
Seit 2025 veröffentlicht MondWild kontinuierlich eigene Musik. 2026 stand sie unter anderem beim StuStaCulum und beim Isarinselfest in München, sowie beim Alles Gute Festival in Innsbruck auf der Bühne.



    </p>;


    return (<section id='about'>

        <div className='text-card-container'>
            <h1 className='section-header'>Bio</h1>

            <div className="row">
                <div className="col-sm-7">

                    {description}



                    <br />


                    <h4>Pressestimmen</h4>

                        <div className="press-item">
                        <a
                            href="https://frequenzmagazin.de/was-hoert-muenchen-juli/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Frequenz Magazin – „Blickkontaktabbruch“
                        </a>

                        <blockquote>
                            „Hier kommen Storytelling und clubbige Beats zusammen. Tanzbar und mit emotionaler Tiefe zugleich.“
                        </blockquote>
                    </div>

                    <div className="press-item">
                        <a
                            href="https://www.berlinonair.cc/post/822303601367171072/mondwild-blickkontaktabbruch-dream-house"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Berlin on Air – „Blickkontaktabbruch“
                        </a>

                        <blockquote>
                            „Ein wirklich innovativer Elektrosound mit einem starken
                            Wiedererkennungswert.“
                        </blockquote>
                    </div>

                    <div className="press-item">
                        <a
                            href="https://indie-tapes.com/post/822138042874773505/mondwild-blickkontaktabbruch-indie-pop"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Indie Tapes – „Blickkontaktabbruch“
                        </a>

                        <blockquote>
                            "MondWild combines narrative vocals with modern electronic sounds and
                            creates a captivating pop arrangement with innovative textures."
                        </blockquote>
                    </div>

                    <div className="press-item">
                        <a
                            href="https://frontstage-magazine.de/2026/06/27/mondwild-veroeffentlicht-neue-single-blickkontaktabbruch/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Frontstage Magazine – „Blickkontaktabbruch“
                        </a>

                        <blockquote>
                            „Mit ihrem unverwechselbaren Sound etabliert sich MondWild zunehmend
                            als spannende Newcomerin der deutschen Electro-Pop-Szene.“
                        </blockquote>
                    </div>

                    <div className="press-item">
                        <a
                            href="https://www.instagram.com/p/Da2WFlDCDFJ/?img_index=9"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Pop Auf'm Schirm – „Blickkontaktabbruch“
                        </a>

                        <blockquote>
                            „Mit ihrer neuen Single ‚Blickkontaktabbruch‘ bringt MondWild ihr
                            zentrales Thema auf den Punkt: den Mut, den eigenen Weg zu gehen.“
                        </blockquote>
                    </div>

                    <div className="press-item">
                        <a
                            href="https://www.instagram.com/p/DYosvpdCEhs/?img_index=8"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Pop Auf'm Schirm – „Anleitung zur Unsichtbarkeit“
                        </a>

                        <blockquote>
                            „Eine tanzbare Dream-House-Hymne über den Ausbruch aus gesellschaftlicher
                            Anpassung.“
                        </blockquote>
                    </div>
                    <br />

                    <h4>Interviews</h4>

                    <ul className="press-links">
                        <li>
                            <a
                                href="https://www.barfuss.it/leute/ich-will-musik-machen-die-koerperlich-und-innerlich-bewegt/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Barfuss – „Ich will Musik machen, die körperlich und innerlich bewegt“
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://salto.bz/de/article/06032026/mondwild-im-takt-der-maschinen"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Salto.bz – Interview zur Single „Maschinen“
                            </a>
                        </li>
                    </ul>
                    <br />


                    <h4>Werdegang</h4>

                    <table>
                        <tbody>
                            <tr>
                                <td>2025</td>
                                <td>Release der ersten selbstproduzierten Singles</td>
                            </tr>
                            <tr>
                                <td>2024-2025</td>
                                <td>Erlernen der elektronischen Musikproduktion, Electronic Music Production und Sound Selling Certificate an der SAE München</td>
                            </tr>
                            <tr>
                                <td>2017-2023</td>
                                <td>Singer-Songwriterin mit Gitarre</td>
                            </tr>
                            <tr>
                                <td>2014-2015</td>
                                <td>Rockband, Gitarristin</td>
                            </tr>
                        </tbody>
                    </table>




                </div>
                <div className="col-sm-5">
                    <img style={{ width: '100%' }}
                        src={foto}
                    />
                    <div className="image-copyright">©Rodrigo Klemens Wulfhorst</div>


                </div>
            </div>
        </div>
    </section>

    );
}